import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetDeliveryScheduleQueryVariables = Types.Exact<{
  deliveryScheduleId: Types.Scalars['String']['input'];
}>;


export type GetDeliveryScheduleQuery = { __typename?: 'Query', deliverySchedule?: { __typename?: 'DeliveryScheduleStateData', tenantId: string, deliveryScheduleId: string, name: string, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, locationIds: Array<string>, status: Types.DeliveryScheduleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null };

export type GetAllDeliverySchedulesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DeliveryScheduleDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.DeliveryScheduleDocumentSortInput> | Types.DeliveryScheduleDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllDeliverySchedulesQuery = { __typename?: 'Query', allDeliverySchedules?: { __typename?: 'AllDeliverySchedulesConnection', totalCount: number, nodes?: Array<{ __typename?: 'DeliveryScheduleDocument', id: string, tenantId: string, deliveryScheduleId: string, name: string, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, locationIds: Array<string>, status: Types.DeliveryScheduleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetDeliverySchedulesForLookupQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DeliveryScheduleDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetDeliverySchedulesForLookupQuery = { __typename?: 'Query', allDeliverySchedules?: { __typename?: 'AllDeliverySchedulesConnection', totalCount: number, nodes?: Array<{ __typename?: 'DeliveryScheduleDocument', id: string, deliveryScheduleId: string, friday: boolean, monday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type DeliveryScheduleDetailsFragment = { __typename?: 'DeliveryScheduleStateData', tenantId: string, deliveryScheduleId: string, name: string, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, locationIds: Array<string>, status: Types.DeliveryScheduleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type DeliveryScheduleLookupFieldsFragment = { __typename?: 'DeliveryScheduleDocument', id: string, deliveryScheduleId: string, friday: boolean, monday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean };

export type DeliveryScheduleDocumentFragment = { __typename?: 'DeliveryScheduleDocument', id: string, tenantId: string, deliveryScheduleId: string, name: string, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, locationIds: Array<string>, status: Types.DeliveryScheduleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export const DeliveryScheduleDetailsFragmentDoc = new TypedDocumentString(`
    fragment DeliveryScheduleDetails on DeliveryScheduleStateData {
  tenantId
  deliveryScheduleId
  name
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  locationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"DeliveryScheduleDetails"});
export const DeliveryScheduleLookupFieldsFragmentDoc = new TypedDocumentString(`
    fragment DeliveryScheduleLookupFields on DeliveryScheduleDocument {
  id
  deliveryScheduleId
  friday
  monday
  saturday
  sunday
  thursday
  tuesday
  wednesday
}
    `, {"fragmentName":"DeliveryScheduleLookupFields"});
export const DeliveryScheduleDocumentFragmentDoc = new TypedDocumentString(`
    fragment DeliveryScheduleDocument on DeliveryScheduleDocument {
  id
  tenantId
  deliveryScheduleId
  name
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  locationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"DeliveryScheduleDocument"});
export const GetDeliveryScheduleDocument = new TypedDocumentString(`
    query GetDeliverySchedule($deliveryScheduleId: String!) {
  deliverySchedule(deliveryScheduleId: $deliveryScheduleId) {
    ...DeliveryScheduleDetails
  }
}
    fragment DeliveryScheduleDetails on DeliveryScheduleStateData {
  tenantId
  deliveryScheduleId
  name
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  locationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const GetAllDeliverySchedulesDocument = new TypedDocumentString(`
    query GetAllDeliverySchedules($where: DeliveryScheduleDocumentFilterInput, $order: [DeliveryScheduleDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  allDeliverySchedules(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...DeliveryScheduleDocument
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment DeliveryScheduleDocument on DeliveryScheduleDocument {
  id
  tenantId
  deliveryScheduleId
  name
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  locationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetDeliverySchedulesForLookupDocument = new TypedDocumentString(`
    query GetDeliverySchedulesForLookup($where: DeliveryScheduleDocumentFilterInput, $first: Int, $after: String) {
  allDeliverySchedules(where: $where, first: $first, after: $after) {
    nodes {
      ...DeliveryScheduleLookupFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment DeliveryScheduleLookupFields on DeliveryScheduleDocument {
  id
  deliveryScheduleId
  friday
  monday
  saturday
  sunday
  thursday
  tuesday
  wednesday
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetDeliverySchedule: build.query<GetDeliveryScheduleQuery, GetDeliveryScheduleQueryVariables>({
      query: (variables) => ({ document: GetDeliveryScheduleDocument, variables })
    }),
    GetAllDeliverySchedules: build.query<GetAllDeliverySchedulesQuery, GetAllDeliverySchedulesQueryVariables | void>({
      query: (variables) => ({ document: GetAllDeliverySchedulesDocument, variables })
    }),
    GetDeliverySchedulesForLookup: build.query<GetDeliverySchedulesForLookupQuery, GetDeliverySchedulesForLookupQueryVariables | void>({
      query: (variables) => ({ document: GetDeliverySchedulesForLookupDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetDeliveryScheduleQuery, useLazyGetDeliveryScheduleQuery, useGetAllDeliverySchedulesQuery, useLazyGetAllDeliverySchedulesQuery, useGetDeliverySchedulesForLookupQuery, useLazyGetDeliverySchedulesForLookupQuery } = injectedRtkApi;
